import { AlertTriangle, CheckCircle, Phone, Mail } from 'lucide-react';

interface WaitingForModelFileProps {
  /** When true, banner title uses Inventory Clean Up Required */
  inventoryCleanUp?: boolean;
}

export const WaitingForModelFile = ({ inventoryCleanUp = false }: WaitingForModelFileProps) => {
  const title = inventoryCleanUp
    ? 'Inventory Clean Up Required'
    : 'Waiting for Model File';

  return (
    <div className="space-y-6">
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-6">
        <div className="flex items-start space-x-3">
          <AlertTriangle className="h-6 w-6 text-amber-600 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-lg font-semibold text-amber-800 mb-2">{title}</h3>
            <p className="text-amber-700">
              Action needed from your team: make sure the models you want in the Shop are complete
              before we can continue building your app.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">
          What each model needs
        </h2>
        <p className="text-gray-600 text-sm mb-4">
          Ensure that each model you want available through the Shop has:
        </p>
        <ul className="space-y-3">
          {[
            'Rate',
            'Term',
            'Retail Price',
            'Image (Image URL)',
            'Show on Web / Mobile checkbox checked',
          ].map((item) => (
            <li key={item} className="flex items-start space-x-3">
              <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-800">{item}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-blue-900 mb-3">
          Contact VersiRent Support for assistance
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex items-center space-x-3">
            <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center">
              <Phone className="h-4 w-4" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">Phone</p>
              <a href="tel:6017030324" className="text-blue-700 hover:text-blue-900">
                601-703-0324
              </a>
            </div>
          </div>
          <div className="flex items-center space-x-3">
            <div className="bg-blue-100 text-blue-800 rounded-full w-8 h-8 flex items-center justify-center">
              <Mail className="h-4 w-4" />
            </div>
            <div>
              <p className="text-sm font-medium text-gray-900">Email</p>
              <a
                href="mailto:support@idealss.com"
                className="text-blue-700 hover:text-blue-900"
              >
                support@idealss.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
